import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7 } from "styled-components";
import { RichText } from "~/features/ui/rich-text";
import { Headline } from "~/features/ui/headline";
import { Grid } from "~/features/ui/grid";
export type HeaderProps = {
  headline?: string;
  text?: string;
  link?: React.ReactNode;
  alignment: "horizontal" | "vertical";
};
function HorizontalHeader(props: HeaderProps) {
  const {
    headline,
    text,
    link
  } = props;
  return <_StyledGrid>
      {headline && <_StyledDiv $_css={[{
      "gridColumn": "1 / -1",
      "@media (min-width: 1024px)": {
        "gridColumn": "span 6 / span 6"
      }
    }]}>
          <_StyledHeadline type="h2" text={headline} />
        </_StyledDiv>}
      {(link || text) && <_StyledDiv2 $_css2={[{
      "gridColumn": "1 / -1",
      "display": "none",
      "rowGap": "1.6rem",
      "@media (min-width: 1024px)": {
        "gridColumn": "span 6 / span 6",
        "display": "flex",
        "flexDirection": "column",
        "rowGap": "2.4rem",
        "placeSelf": "end"
      }
    }]}>
          {text && <RichText text={text} />}
          {link && <div>{link}</div>}
        </_StyledDiv2>}
    </_StyledGrid>;
}
function VerticalHeader(props: HeaderProps) {
  const {
    headline,
    text,
    link
  } = props;
  return <_StyledDiv3>
      {headline && <_StyledHeadline2 type="h2" text={headline} />}
      {(link || text) && <_StyledDiv4 $_css3={[{
      "marginTop": "auto",
      "display": "flex",
      "flexDirection": "column",
      "rowGap": "1.6rem"
    }]}>
          {text && <RichText text={text} />}
          {link && <div>{link}</div>}
        </_StyledDiv4>}
    </_StyledDiv3>;
}
export function SectionHeader(props: HeaderProps) {
  return props.alignment === "horizontal" ? <HorizontalHeader {...props} /> : <VerticalHeader {...props} />;
}
var _StyledGrid = _styled(Grid).withConfig({
  componentId: "sc-sf-1lnglpr-0"
})({
  "rowGap": "1.6rem"
});
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-1lnglpr-1"
})`${p => p.$_css}`;
var _StyledHeadline = _styled3(Headline).withConfig({
  componentId: "sc-sf-1lnglpr-2"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-1lnglpr-3"
})`${p => p.$_css2}`;
var _StyledDiv3 = _styled5("div").withConfig({
  componentId: "sc-sf-1lnglpr-4"
})({
  "display": "flex",
  "height": "100%",
  "flexDirection": "column",
  "rowGap": "1.6rem"
});
var _StyledHeadline2 = _styled6(Headline).withConfig({
  componentId: "sc-sf-1lnglpr-5"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledDiv4 = /*#__PURE__*/_styled7("div").withConfig({
  displayName: "header___StyledDiv4",
  componentId: "sc-rplf7l-0"
})(["", ""], p => p.$_css3);